/**
 * TODO:
 * We shouldn't use core colors in components, like (lime).
 * but as we don't have the colors mapped on semantic layers yet,
 * we will keep using core colors for now.
 * @see https://etherapists.atlassian.net/browse/HUM-23690
 */

import { cva } from 'class-variance-authority';

export const progressRootVariants = cva(
  'bg-primary-100 relative h-3 w-full overflow-hidden rounded-full',
  {
    variants: {
      variant: {
        default: 'bg-primary-100',
        destructive: 'bg-destructive-100',
        success: 'bg-lime-100',
      },
    },
    defaultVariants: { variant: 'default' },
  }
);

export const progressIndicatorVariants = cva('h-full w-full flex-1 transition-all', {
  variants: {
    variant: { default: 'bg-primary', destructive: 'bg-destructive', success: 'bg-lime-600' },
  },
  defaultVariants: { variant: 'default' },
});

export const progressIndicatorsVariants = cva('absolute top-0 h-1 w-1 mt-1 rounded-full', {
  variants: {
    variant: {
      default: 'bg-primary-200',
      destructive: 'bg-destructive-200',
      success: 'bg-lime-200',
    },
  },
  defaultVariants: { variant: 'default' },
});
